import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Path } from "../../constants/path";
import NotFoundScreen from "../other/NotFoundScreen";
import IndexScreen from "./IndexScreen";
import ViewScreen from "./ViewScreen";

class BaseScreen extends PureComponent {
  render = () => {
    return (
      <Switch>
        <Route exact path={Path.fairs.url} component={IndexScreen} />
        <Route path={Path.fairs.view.url} component={ViewScreen} />
        <Route component={NotFoundScreen} />
      </Switch>
    );
  };
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BaseScreen),
);
